import { GridRowId, useGridApiRef } from '@mui/x-data-grid-pro';
import { useCallback } from 'react';
import { useFieldArray, useFormContext } from 'react-hook-form';

import { QuoteLineItemGridField } from '../../NegotiationQuoteDetailsWidget.types';
import { QuoteFormData } from '../QuoteDetailsForm/QuoteDetailsForm.schema';
import { TsrctQuoteItemUpdatableStatus } from '@/generated/gql/graphql';
import { DataGridProStyled } from '~/components/DataGridCustom';

import { useQuoteEditDataGridConfig } from './QuoteDetailsLineItemsForm.dataGrid';

export const QuoteDetailsLineItemsForm = () => {
  const { setValue } = useFormContext<QuoteFormData>();
  const { fields } = useFieldArray<QuoteFormData, 'quote.lineItems'>({
    name: 'quote.lineItems',
    shouldUnregister: true,
  });
  const apiRef = useGridApiRef();

  const getRowIndex = useCallback(
    (rowId: GridRowId) => {
      const rowIds = apiRef.current.getAllRowIds();
      const rowIndex = rowIds.findIndex((rId) => rId === rowId);
      return rowIndex;
    },
    [apiRef],
  );

  const onStatusChange = useCallback(
    (rowId: string | number, newStatus: TsrctQuoteItemUpdatableStatus) => {
      const index = fields.findIndex((f) => f.id === rowId);
      if (index !== -1) {
        setValue(`quote.lineItems.${index}.status`, newStatus);
      }
    },
    [fields, setValue],
  );

  const config = useQuoteEditDataGridConfig({ getRowIndex, onStatusChange });
  const { columnVisibilityModel } = config;

  return (
    <>
      <DataGridProStyled
        {...config}
        apiRef={apiRef}
        autoHeight
        hideFooter
        disableColumnMenu
        rows={fields as any} // TODO: Temporary fix only - derived GridConfig type QuoteLineItemGridRow needs to be revisited
        getRowId={(row) => row.id}
        sx={{
          '& .MuiDataGrid-row': { cursor: 'default' },
        }}
        initialState={{
          pinnedColumns: { right: [QuoteLineItemGridField.STATUS] },
        }}
        columnVisibilityModel={columnVisibilityModel}
        rowSelection={false}
        sortingMode={'server'}
      />
    </>
  );
};
